import notificationApi from '@/api/admin/notificationApi'
import { queryKeys } from '@/constant/common'
import { NotificationSearchParams, AlertResponse } from '@/types/notification'
import { QueryOptions, UseQueryResult, useQuery } from '@tanstack/react-query'

interface NotificationListResponse {
  page: number
  size: number
  totalPage: number
  totalCount: number
  list: AlertResponse[]
}

function useNotifications(
  objectId: string,
  searchParams: Omit<NotificationSearchParams, 'ObjectId'> = {},
  queryOptions?: QueryOptions,
): UseQueryResult<NotificationListResponse, any> {
  return useQuery(
    [queryKeys.notifications, objectId, searchParams],
    async () => {
      const { data } = await notificationApi.getNotificationsByObjectId(objectId, searchParams)

      return {
        page: data.page,
        size: data.size,
        totalPage: data.totalPage,
        totalCount: data.totalCount,
        list: data.data || [],
      }
    },
    queryOptions,
  )
}

export default useNotifications
